/*
 * UIGenerator
 *
 * created by Guy Green 2017
 */

class UIGenerator {
  constructor(imagesDir) {
    this.imagesDir = imagesDir;
    this.classStyles = [];
    this.styleElement = -1;
    this.registerClassStyle = function (className, styleObj) {
      const styleString = this.parseStyleObject(styleObj);
      if (this.classStyles[className]) {
        this.classStyles[className] += styleString;
      }

      this.classStyles[className] = styleString;
    };

    this.parseStyleWithSelector = function (styleObj) {
      const selector = styleObj.selector;
      return selector + '{' + this.parseStyleObject(styleObj.style) + '}';
    };
    this.injectStyleToDocument = function (styleConf) {
      let styleStringToAdd = '';
      if (this.styleElement === -1) {
        this.styleElement = document.createElement('style');
        this.styleElement.className = 'UIGenerator_generated_style';
        this.styleElement.type = 'text/css';
        document.getElementsByTagName('head')[0].appendChild(this.styleElement);
      }

      if (styleConf.length) {
        for (let i = 0; i < styleConf.length; i++) {
          styleStringToAdd += '\n' + this.parseStyleWithSelector(styleConf[i]);
        }
      } else {
        styleStringToAdd = this.parseStyleWithSelector(styleConf);
      }

      this.styleElement.innerHTML = this.styleElement.innerHTML + styleStringToAdd;
    };

    this.generateInput = function (inputID, inputPlaceholder, inputClass) {
      const input =
        "<input id='" + inputID + "' class='" + inputClass + "' placeholder='" + inputPlaceholder + "'></input>";

      return input;
    };

    this.generateFormButton = function (buttonID, buttonText, buttonClass) {
      const button = "<div class='" + buttonClass + "' id='" + buttonID + "'>" + buttonText + '</div>';
      return button;
    };

    this.parseElementAttribute = function (attributeName, attributeValue) {
      if (typeof attributeValue === 'undefined') {
        return '';
      } else {
        return ' ' + attributeName + "='" + attributeValue + "' ";
      }
    };

    this.parseStyleObject = function (styleObj) {
      if (typeof styleObj === 'string') {
        return styleObj;
      }

      let styleString = '';
      for (const styleName in styleObj) {
        styleString += styleName.replace(/([A-Z])/g, '-$1').toLowerCase() + ':' + styleObj[styleName] + '; ';
      }

      return styleString;
    };

    this.parseClassNames = function (classString) {
      const classes = classString.replace(/\s+/g, ' ').split(' ');
      return classes;
    };

    this.parseAttributes = function (attributes) {
      let attributesHTML = '';
      let gotStyle = false;

      let styleString = '';
      let classStyleString = '';
      for (const key in attributes) {
        const attributeName = key;
        const attributeValue = attributes[key];

        if (key === 'class') {
          const classes = this.parseClassNames(attributeValue);
          for (let i = 0; i < classes.length; i++) {
            const currentClass = classes[i];
            if (this.classStyles[currentClass]) {
              classStyleString += this.classStyles[currentClass];
              gotStyle = true;
            }
          }
        }

        if (key === 'style') {
          styleString += this.parseStyleObject(attributeValue);
          gotStyle = true;
          continue;
        }

        attributesHTML += this.parseElementAttribute(attributeName, attributeValue);
      }

      if (gotStyle) {
        attributesHTML += this.parseElementAttribute('style', classStyleString + styleString);
      }

      return attributesHTML;
    };

    this.generateHTML = function (config) {
      if (typeof config.type === 'undefined') {
        config.type = 'div';
      }

      const elementType = config.type;
      const attributes = config.attributes;
      let innerHtml = config.innerHTML;

      let attributesString = '';
      if (typeof attributes !== 'undefined') {
        attributesString = this.parseAttributes(attributes);
      }

      if (typeof innerHtml === 'undefined') {
        innerHtml = '';
      }

      const newElement = '<' + elementType + ' ' + attributesString + '>' + innerHtml + '</' + elementType + '>';

      return newElement;
    };

    this.generateAndAddHTML = function (parent, elementConfig) {
      const newElement = this.generateHTML(elementConfig);
      parent.append(newElement);
      return newElement;
    };

    this.generateLoader = function (loaderID, loaderText, classPrefix) {
      if (typeof loaderText === 'undefined') {
        loaderText = 'loading...';
      }
      const loaderContainerOpen = "<div class='" + classPrefix + "_loader_container' id='" + loaderID + "'>";
      const loaderContainerClose = '</div>';

      const loaderInnerContainerOpen = "<div class='" + classPrefix + "_loader_inner_container'>";
      const loaderInnerContainerClose = '</div>';
      const loaderHTML = "<div class='" + classPrefix + "_loader_text'>" + loaderText + '</div>';
      const loaderImage =
        "<img class='" + classPrefix + "_loader' src='" + this.imagesDir + "timoccoJuggleAnim.gif'></img>";

      return (
        loaderContainerOpen +
        loaderInnerContainerOpen +
        loaderImage +
        loaderHTML +
        loaderInnerContainerClose +
        loaderContainerClose
      );
    };
  }
}

export default UIGenerator;
